import { render, staticRenderFns } from "./CreatePackingSlip.vue?vue&type=template&id=6b0765de&scoped=true&"
import script from "./CreatePackingSlip.vue?vue&type=script&lang=js&"
export * from "./CreatePackingSlip.vue?vue&type=script&lang=js&"
import style0 from "./CreatePackingSlip.vue?vue&type=style&index=0&id=6b0765de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0765de",
  null
  
)

export default component.exports